import React from 'react';

import CardGrid from '../components/CardGrid';
import EmptyState from '../components/EmptyState';
import EventCard from '../components/EventCard';
import Hero from '../components/Hero';
import Section from '../components/Section';
import SectionHero from '../components/SectionHero';

const EventsIndexTemplate = ({ pageContext: { page, entries } }) => {
  const [upcomingEvents, pastEvents] = entries.reduce(
    ([u, p], e) =>
      new Date(e.starts) > new Date() ? [[...u, e], p] : [u, [...p, e]],
    [[], []]
  );

  return (
    <React.Fragment>
      <Section>
        <Hero {...page} />
      </Section>
      <Section colour="light">
        <SectionHero title="Upcoming Events" />
        {!upcomingEvents.length ? (
          <EmptyState message="No upcoming events" />
        ) : (
          <CardGrid entries={upcomingEvents} Component={EventCard} {...page} />
        )}
      </Section>
      <Section>
        <SectionHero title="Past Events" />
        {!pastEvents.length ? (
          <EmptyState message="No past events" />
        ) : (
          <CardGrid entries={pastEvents} Component={EventCard} {...page} />
        )}
      </Section>
    </React.Fragment>
  );
};

export default EventsIndexTemplate;
